import React, { useState } from 'react'
import styles from './PlanLayout.module.css'
import CTAPopup from '../../components/CTAPopup/CTAPopup'

import masterPlanImg from '../../assets/master.png'
import unitPlanImg from '../../assets/unitplan.png'

const plans = [
    {
        title: 'Master Layout',
        label: 'Site Plan',
        description: 'An overview of the entire development — towers, landscaping, amenity zones and open spaces.',
        image: masterPlanImg,
        requestLabel: 'Request Master Plan Layout',
    },
    {
        title: 'Unit Layout',
        label: 'Floor Plan',
        description: 'Detailed floor plans across 3, 4 & 5 BHK configurations with precise room dimensions.',
        image: unitPlanImg,
        requestLabel: 'Request Unit Plan Layout',
    },
]

const PlanLayout = () => {
    const [popupOpen, setPopupOpen] = useState(false)

    return (
        <>
            <section className={styles.section}>

                <div className={styles.header}>
                    <span className={styles.eyebrow}>
                        <span className={styles.eyebrowLine}></span>
                        FLOOR PLANS
                        <span className={styles.eyebrowLine}></span>
                    </span>
                    <h2 className={styles.heading}>
                        Spaces <em>Thoughtfully Designed</em>
                    </h2>
                    <p className={styles.subheading}>
                        Thoughtfully designed floor plans for modern living with optimal space utilization.
                    </p>
                </div>

                <div className={styles.grid}>
                    {plans.map((plan, i) => (
                        <div
                            key={i}
                            className={styles.card}
                            onClick={() => setPopupOpen(true)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && setPopupOpen(true)}
                        >
                            {/* Image */}
                            <div className={styles.imgWrapper}>
                                <img
                                    src={plan.image}
                                    alt={plan.title}
                                    className={styles.img}
                                />
                                <div className={styles.imgOverlay}></div>
                                <div className={styles.imgLabel}>
                                    <span className={styles.imgLabelText}>{plan.requestLabel}</span>
                                    <span className={styles.imgLabelIcon}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                        </svg>
                                    </span>
                                </div>
                                <span className={styles.planBadge}>{plan.label}</span>
                            </div>

                            {/* Footer */}
                            <div className={styles.cardFooter}>
                                <div className={styles.cardInfo}>
                                    <span className={styles.cardTitle}>{plan.title}</span>
                                    <p className={styles.cardDesc}>{plan.description}</p>
                                </div>
                                <button
                                    className={styles.btn}
                                    onClick={(e) => { e.stopPropagation(); setPopupOpen(true) }}
                                >
                                    Request Floor Plan
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

            </section>

            <CTAPopup isOpen={popupOpen} onClose={() => setPopupOpen(false)} />
        </>
    )
}

export default PlanLayout